// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"rg_a","PostMenu__item--moderator":"rg_b","PostMenu__item--author":"rg_c"};